import React, { useEffect, useRef } from 'react';
import ButtonDownload from './ButtonDownload';
import styles from './InputFile.module.scss';
import LabelFile from './LabelFile';

function InputHidden({ name, className, refValue, formik, ...rest }) {
    return (
        <input
            type="file"
            name={name}
            className={`${className} ${styles.input}`}
            id={name}
            {...rest}
            ref={refValue}
            onChange={(ev) => {
                if (ev?.currentTarget?.files) {
                    formik.setFieldValue(name, ev.currentTarget.files[0]);
                    refValue.current.value = null;
                }
            }}
        />
    );
}

export default function InputFile({
    name,
    formik,
    className,
    disabled = false,
    optionAnexo = 'anexo',
    optionName = 'nome',
    enableDownload = true,
    thumb,
    ...rest
}) {
    const fileName = formik.values[name]?.name ?? formik.values[name]?.nome;
    const ref = useRef(null);

    useEffect(() => {
        if (formik.values[name] === '') {
            ref.current.value = null;
        }
    }, [fileName]);

    const icon = fileName ? 'pi-sync' : 'pi-plus';
    const text = fileName ? 'Alterar' : 'Carregar';

    return (
        <>
            {thumb && <div className={styles.thumbContainer}>{thumb}</div>}
            <div className={styles.container}>
                <LabelFile
                    disabled={disabled}
                    name={name}
                    icon={icon}
                    fileName={fileName}
                    text={text}
                />
                {enableDownload && (
                    <ButtonDownload
                        disabled={disabled}
                        optionAnexo={optionAnexo}
                        optionName={optionName}
                        fileName={fileName}
                        formik={formik}
                        name={name}
                    />
                )}
            </div>

            <InputHidden
                refValue={ref}
                name={name}
                formik={formik}
                className={className}
                {...rest}
            />
        </>
    );
}
